import React, { useCallback, useState } from 'react'
import { ButtonsWrapper, ChangeTipsContent, ChangeTipsText, Sum, SumContent, SumText, TextInputWrapper } from '../index.styled'
import Button from '../../../buttons/Button'
import CustomModal from '../../../modal/CustomModal'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import Currency from '../../../currency'
import { getFloat, roundPrice } from '../../../../../helper'
import TextInputControlled from '../../../inputs/TextInput/controlled'
import { setTap2PayTips } from '../../../../../redux/action/tap2Pay'
import { handleInputChange } from '../helper'

const EVENT_Z_INDEX = 96

const ModalChangeTips = React.memo(({ totalPrice,isOpen, setShowProcessPaymentTap2PayModal, setShowTipSelectionModal, setShowChangeTipsModal }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const [customerGivenSum, setCustomerGivenSum] = useState('0')
	const customerGivenSumNumber = +customerGivenSum.replace(',', '.')
	const roundedTotalPrice = roundPrice(totalPrice + customerGivenSumNumber)

	const handleChange = (e) => {
		handleInputChange(e.target.value, setCustomerGivenSum)
	}

	const handleOnBlur = () => {
		const formattedValue = customerGivenSum ? (getFloat(customerGivenSum).toFixed(2).replace('.', ',')).toString() : customerGivenSum
		setCustomerGivenSum(formattedValue)
	}

	const handleFocus = () => {
		if (!+customerGivenSum) setCustomerGivenSum('')
	}

	const handleClose = useCallback(() => {
		setShowChangeTipsModal(false)
		setShowTipSelectionModal(true)
		setCustomerGivenSum('0')
	}, [setShowTipSelectionModal, setShowChangeTipsModal])

	const handleGreenButtonClick = useCallback(() => {
		dispatch(setTap2PayTips(customerGivenSumNumber))
		setShowProcessPaymentTap2PayModal(true)
		setShowChangeTipsModal(false)
		setCustomerGivenSum('0')
	}, [dispatch, customerGivenSumNumber, setShowProcessPaymentTap2PayModal, setShowChangeTipsModal])

	const handleBack = useCallback(() => {
		handleClose()
	}, [handleClose])

	return (
		<CustomModal isOpen={isOpen}
								 close={handleClose}
								 id="modal-change-tips"
								 size="x-small"
								 title={t('Tap2PayModals.tip')}
								 disableBackButton={true}
								 zIndex={EVENT_Z_INDEX}
								 button={<ButtonsWrapper>
									 <Button name="back" icon="back" text={t('Cart.Buttons.back')} zIndex={EVENT_Z_INDEX} color="gray" onClick={handleBack} />
									 <Button name="send" icon="tap2Pay" text={t('Cart.Buttons.pay')} zIndex={EVENT_Z_INDEX} color="green" onClick={handleGreenButtonClick} />
								 </ButtonsWrapper>}>
			<ChangeTipsContent>
				<SumContent>
					<SumText>{t('Tap2PayModals.total')}:</SumText>
					<Sum><Currency>{roundedTotalPrice}</Currency></Sum>
					<SumText>{t('Tap2PayModals.addTips')}</SumText>
				</SumContent>
				<TextInputWrapper>
					<TextInputControlled name="discount"
															 label={t('Tap2PayModals.changeTips.label')}
															 testId="discount"
															 value={customerGivenSum}
															 onChange={handleChange}
															 onBlur={handleOnBlur}
															 color="gray"
															 onFocus={handleFocus} />
					<ChangeTipsText>{t('Tap2PayModals.changeTips.text')}</ChangeTipsText>
				</TextInputWrapper>
			</ChangeTipsContent>
		</CustomModal>
	)
})

ModalChangeTips.displayName = 'ModalChangeTips'
export default ModalChangeTips
